/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface FrameTextBlockData
 */
export interface FrameTextBlockData {
  /**
   *
   * @type {string}
   * @memberof FrameTextBlockData
   */
  content: string
}

/**
 * Check if a given object implements the FrameTextBlockData interface.
 */
export function instanceOfFrameTextBlockData(
  value: object
): value is FrameTextBlockData {
  if (!('content' in value) || value['content'] === undefined) return false
  return true
}

export function FrameTextBlockDataFromJSON(json: any): FrameTextBlockData {
  return FrameTextBlockDataFromJSONTyped(json, false)
}

export function FrameTextBlockDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FrameTextBlockData {
  if (json == null) {
    return json
  }
  return {
    content: json['content'],
  }
}

export function FrameTextBlockDataToJSON(
  value?: FrameTextBlockData | null
): any {
  if (value == null) {
    return value
  }
  return {
    content: value['content'],
  }
}
